import TopicFromParamsRoute from "discourse/routes/topic/from-params";

export default TopicFromParamsRoute;
